import React from 'react';
export function EditorParagraphIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 3a1 1 0 00-1-1H9a6 6 0 100 12h2a1 1 0 100-2H9a4 4 0 110-8h4v17a1 1 0 102 0V4h2v17a1 1 0 102 0V4h1a1 1 0 001-1z"
  }));
}